import comm from "csi/comm";
import BooleanController from "csi/heading/BooleanController";
import { callConstructFieldsOnWriter, createFormFieldKeysFromLegacyFormFieldKeys, LEGACY_FORM_DEFINITION_PREFIX } from "csi/middleware/form/formUtility";
import MessageDialog from "csi/widget/MessageDialog";
import declare from "dojo/_base/declare";

const IsNewFormBuilderController = declare(BooleanController, {
	/** the checkbox widget */
	checkbox: null,

	/** the legacy form field keys */
	legacyFormFieldKeys: null,

	/** the legacy form field paths */
	legacyFormFieldPaths: null,

	/**
	 * @override
	 * Enable the confirmation dialog for the action.
	 */
	hasToConfirmAction(): boolean {
		return !this._getCheckboxValue();
	},

	/**
	 * @override
	 * Customize the confirmation dialog.
	 */
	confirmAction(params: {
		buttons: string[];
		materialIcon: string;
		message: string;
		title: string;
	}): void {
		params.buttons = [MessageDialog.BUTTON_CONTINUE, MessageDialog.BUTTON_CANCEL];
		params.materialIcon = MessageDialog.ICON_ERROR;
		params.message = this.getMessage();
		params.title = this.getTitle();
		this.inherited(arguments);
	},

	/**
	 * @override
	 * Reset the checkbox value if the user cancels the confirmation dialog.
	 */
	onConfirm(key: string): void {
		if (key === MessageDialog.BUTTON_CANCEL) {
			this.checkbox.set("value", this.oldValue);
			this.postProcess();
		} else {
			this.preProcess();
		}
	},

	/**
	 * @override
	 * In the onPreActionDeferreds, fetch the latest version of the form definition.
	 */
	onPreActionDeferreds(dfds: PromiseLike<any>[]): void {
		const nodeType = this.m_cache.get(this.getNode().__Parent__).$Name;
		const url = `${LEGACY_FORM_DEFINITION_PREFIX}/${nodeType}`;
		dfds.push(comm.getNodeRequest(url).go()
			.then((res) => {
				const node = res.getResultNode();
				if (!node) {
					return;
				}
				this.legacyFormFieldKeys = node.ConfigurableAttributes;
				this.legacyFormFieldPaths = node.AttributePaths;
			}));
		this.inherited(arguments);
	},

	/**
	 * @override
	 * Run the migration if the user confirms and the checkbox value is false.
	 */
	toWriter(): void {
		const { legacyFormFieldKeys, legacyFormFieldPaths, m_writer, m_cache } = this;
		// if the checkbox is checked, then run the migration
		if (this._getCheckboxValue() && legacyFormFieldKeys && legacyFormFieldPaths) {
			const node = this.getNode();
			// get the node type from the parent node name (FormDefinitionConfig)
			const nodeType = m_cache.get(node.__Parent__).$Name;
			const formFieldKeys = createFormFieldKeysFromLegacyFormFieldKeys(nodeType, legacyFormFieldKeys, legacyFormFieldPaths);
			callConstructFieldsOnWriter(m_writer, node.$URL, formFieldKeys);
		}
		this.inherited(arguments);
	},
});

export = IsNewFormBuilderController;
